import routes from './routes';

export * from './api/index';
export * from './Components/index';
export * from './Pages/index';

export default routes;
